export const notificationOption = [
    {
        value: 'sms',
        label: 'SMS / Text Message',
        option: 'A',
        instruction: 'Via Text Message (SMS) to your smartphone',
    },
    {
        value: 'email',
        label: 'Email',
        option: 'B',
        instruction: "Via Email (best option if you don't have a smartphone)",
    },
];
